import React, { FC, InputHTMLAttributes } from 'react';
import '../form.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';

interface TimezoneDateTimeRangePickerProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  Controller: any;
  control?: any;
  placeholder?: string;
  label?: string;
  errors?: any;
  register?: any;
  wrapperClass?: string;
  className?: string;
  isClearable?: boolean;
  disabled?: boolean;
  timezone: string;
  minDate?: Date;
  maxDate?: Date;
  selectsStart?: boolean;
  selectsEnd?: boolean;
  startDate?: Date;
  endDate?: Date;
}

const TimezoneDateTimeRangePicker: FC<TimezoneDateTimeRangePickerProps> = ({
  placeholder,
  Controller,
  control,
  name,
  errors,
  label,
  wrapperClass,
  isClearable = false,
  disabled = false,
  minDate,
  maxDate,
  timezone,
  selectsStart = false,
  selectsEnd = false,
  startDate,
  endDate,
  ...rest
}) => {
  const setLocalZone = (date: Date | null) => {
    const dateWithoutZone = moment.tz(date, timezone).format('YYYY-MM-DDTHH:mm:ss.SSS');
    const localZone = moment(dateWithoutZone).format('Z');
    const dateWithLocalZone = [dateWithoutZone, localZone].join('');

    return new Date(dateWithLocalZone);
  };

  const setBuildingSpecificZone = (date: Date | null) => {
    const dateWithoutZone = moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS');
    const buildingSpecificZone = moment.tz(date, timezone).format('Z');
    const dateWithBuildingZone = [dateWithoutZone, buildingSpecificZone].join('');

    return new Date(dateWithBuildingZone);
  };

  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral9 font-semibold" htmlFor={name}>
          {label}
        </label>
      )}

      <Controller
        control={control}
        name={name}
        {...rest}
        render={({ field: { onChange, value } }: any) => {
          return (
            <DatePicker
              className="input"
              wrapperClassName="w-full"
              placeholderText={placeholder}
              onChange={(date) => onChange(setBuildingSpecificZone(date), undefined)}
              selected={value ? setLocalZone(value) : null}
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              isClearable={isClearable}
              disabled={disabled}
              selectsStart={selectsStart ? selectsStart : undefined}
              selectsEnd={selectsEnd ? selectsEnd : undefined}
              startDate={startDate ? setLocalZone(startDate) : undefined}
              endDate={endDate ? setLocalZone(endDate) : undefined}
              minDate={minDate ? minDate : undefined}
              maxDate={maxDate ? maxDate : undefined}
            />
          );
        }}
      />

      {errors[name] && (
        <span className="error" role="alert">
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default TimezoneDateTimeRangePicker;
